import { render, staticRenderFns } from "./DialogDetailAccomodation.vue?vue&type=template&id=33cef1cb&scoped=true&"
import script from "./DialogDetailAccomodation.vue?vue&type=script&lang=js&"
export * from "./DialogDetailAccomodation.vue?vue&type=script&lang=js&"
import style0 from "./DialogDetailAccomodation.vue?vue&type=style&index=0&id=33cef1cb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cef1cb",
  null
  
)

export default component.exports